export const SET_CONTRAPARTIDAS = "CONTRAPARTIDAS/SET_CONTRAPARTIDAS";
export const SET_CONTRAPARTIDA = "CONTRAPARTIDAS/SET_CONTRAPARTIDA";
export const SET_PAGINATION = "CONTRAPARTIDAS/SET_PAGINATION";
